import { useEffect, useState } from "react";

export default function useIsMobile() {
	const getIsMobile = () => window.innerWidth < 768;

	const [isMobile, setIsMobile] = useState(getIsMobile);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(getIsMobile());
		};

		window.addEventListener("resize", handleResize);
		handleResize();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return isMobile;
}

